<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <!--是否固定  -->
      <div :class="{ 'fixed-header': fixedHeader }">
        <!--面包屑-->
        <navbar />
        <!-- 快捷标签页面-->
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
    </div>
    <accountCPFTip ref="cpfFromRef" />
    <WarningTrajectoryTip ref="trajectoryRef" />
    <systemMessagePopUp ref="systemMessagePopUpRef" />
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import TagsView from './components/TagsView';
import accountCPFTip from '@/components/accountCPFTip/index.vue';
import WarningTrajectoryTip from '@/components/WarningTrajectoryTip/index.vue';
import { getExpressWmsLink } from '@/api/serialPort';
import { checkCPFValidity } from '@/api/user';
import store from '@/store';
import dayjs from 'dayjs';
import systemMessagePopUp from '@/components/systemMessagePopUp/index.vue';
import { getUserPopupMsg } from '@/api/messageCenter';

export default {
  name: 'Layout',
  components: {
    systemMessagePopUp,
    accountCPFTip,
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    WarningTrajectoryTip
  },
  mixins: [ResizeMixin],
  data() {
    return {
      checkCPFValidityObj: {},
      trajectoryTimer: null,
      userIdList: []
      // getmessageShow: false
    };
  },
  computed: {
    needTagsView() {
      return this.$store.state.settings.tagsView;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile' // 开启这在页面缩小到一定程度后就隐藏菜单栏
      };
    }
  },
  created() {
    getExpressWmsLink().then((res) => {
      console.log(res.installer);
      this.$store.dispatch('app/updateExpressWmsPluginLink', res?.installer);
    });
  },
  mounted() {
    this.getUserPopupMessage();
    // 存用户id
    // 1. 读取本地已存储数据  和用户ID列表（初始为空数组）
    const userId = store.getters.userId;
    const storedIds = localStorage.getItem('loginUserIds');
    const userIdListLocal = storedIds ? JSON.parse(storedIds) : [];
    this.getCheckCPFValidity();
    // 1. 获取本地存储的标记和最后触发日期
    const isTrajectoryRequested = localStorage.getItem('isTrajectoryFirstLoad') || 'false';
    const lastTriggerDate = localStorage.getItem('trajectoryLastTriggerDate') || '';
    // 2. day.js 获取今日日期（格式：YYYY-MM-DD，全局统一，无兼容问题）
    const today = dayjs().format('YYYY-MM-DD');
    // 2. 去重：避免重复存储同一个用户ID
    if (userId && !userIdListLocal.includes(userId)) {
      userIdListLocal.push(userId);
      // 3. 重新存入localStorage（JSON字符串格式）
      localStorage.setItem('loginUserIds', JSON.stringify(userIdListLocal));
      // 该账号今天首次登录 必须弹框
      localStorage.setItem('isTrajectoryFirstLoad', 'true');
      localStorage.setItem('trajectoryLastTriggerDate', today); // 记录今日日期
      this.getTrajectoryData(); // 首次登录弹框
    } else {
      // 当存储的日期不一致，则说明是当日首次登录
      if (lastTriggerDate !== today) {
        localStorage.setItem('isTrajectoryFirstLoad', 'true');
        localStorage.setItem('trajectoryLastTriggerDate', today); // 记录今日日期
        this.getTrajectoryData(); // 仅当日首次登录弹框一次
      } else {
        //  isTrajectoryRequested 为 true 时，无序请求轨迹弹框
        if (isTrajectoryRequested !== 'true') {
          localStorage.setItem('isTrajectoryFirstLoad', 'true');
          localStorage.setItem('trajectoryLastTriggerDate', today); // 记录今日日期
          this.getTrajectoryData(); // 仅当日首次登录弹框一次
        }
      }
    }
    this.initTrajectoryTimer();
    this.$nextTick(() => {
      setTimeout(() => {
        this.isFinancePayableManagementUploadContasPage();
      }, 1000);
    });
  },
  beforeDestroy() {
    this.trajectoryTimer && clearInterval(this.trajectoryTimer);
  },
  methods: {
    // 登录查询弹框消息
    getUserPopupMessage() {
      const data = {
        receiveId: store.getters.userId,
        systemType: 1, // 供系统类型 1:快递系统 2:服务商系统应商下的网点
        clientType: 1 // 接收客户端类型 0:全部 1:PC 2:APP
      };
      getUserPopupMsg(data).then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            // isRead 为 0是未读
            if (res.data[0].isRead === 0) {
              this.$refs.systemMessagePopUpRef.openDialog(res.data[0]);
            }
          }
        }
      });
    },
    // 获取用户的cpf（带3分钟请求间隔控制）
    async getCheckCPFValidity() {
      try {
        // 1. 读取本地存储的上次请求时间
        const lastRequestTime = localStorage.getItem('isCPFValidityFirstDate');
        // 2. 初始化是否需要请求接口的标识
        let needRequest = false;
        if (!lastRequestTime) {
          // 无上次请求时间 → 首次请求，需要调用接口
          needRequest = true;
        } else {
          // 有上次时间 → 计算与当前时间的分钟差（使用dayjs精准计算）
          const lastTime = dayjs(lastRequestTime);
          const currentTime = dayjs();
          // 校验时间是否解析有效 + 计算间隔分钟数
          if (!lastTime.isValid() || currentTime.diff(lastTime, 'minute') >= 3) {
            needRequest = true; // 时间解析失败/间隔≥3分钟 → 重新请求
          }
          // 间隔<3分钟 → needRequest为false，跳过接口请求
        }
        // 3. 满足条件才调用接口，否则直接返回（不弹框）
        if (needRequest) {
          const res = await checkCPFValidity();
          // 4. 接口请求成功后，更新本地存储的请求时间为当前时间
          const currentDate = dayjs().format('YYYY-MM-DD HH:mm:ss');
          localStorage.setItem('isCPFValidityFirstDate', currentDate);

          // 原有业务逻辑：赋值+判断弹框
          this.checkCPFValidityObj = res.data || {};
          if (this.checkCPFValidityObj.resultCode === 2) {
            this.$refs.cpfFromRef?.showCpf(this.checkCPFValidityObj);
            // 加?.防护ref未挂载的情况，避免报错
          }
        }
      } catch (error) {
        // 异常捕获：接口请求失败时不阻塞页面，打印错误便于排查
        console.log('获取CPF有效性信息失败：', error);
      }
    },
    // 获取用户的cpf
    getTrajectoryData() {
      // 是否存在付款按钮权限，只有存在一个权限就会显示
      const buttonPermissions = this.$store.getters.button_permissions;
      const isFlage = buttonPermissions.includes('alert:customer-track-stationary');
      console.log('isFlage', isFlage);
      // 判断是否有轨迹弹框更新提示权限功能
      if (isFlage) {
        this.$refs.trajectoryRef.showTrajectory();
      }
    },
    initTrajectoryTimer() {
      this.trajectoryTimer && clearInterval(this.trajectoryTimer);
      this.trajectoryTimer = setInterval(() => {
        console.log('initTrajectoryTimer定时器');
        const now = dayjs();
        if (now.minute() === 0 && [9, 14, 17].includes(now.hour())) {
          this.getTrajectoryData();
        }
      }, 60000);
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
    },
    /**
     * @description 是否跳转到发票上传页面
     * @param path
     * @returns {boolean}
     */
    isFinancePayableManagementUploadContasPage() {
      // 检测是否从 UploadContas 页面进入
      const isFromUploadContas = localStorage.getItem('isFromUploadContas');
      const payableNumber = localStorage.getItem('uploadContasPayableNumber');
      const timeStamp = localStorage.getItem('uploadContasTimeStamp');

      if (isFromUploadContas === 'true' && payableNumber && timeStamp) {
        // 带参跳转到 UploadContas 页面
        this.$router.push({
          path: '/finance/payableManagement/UploadContas',
          query: {
            payableNumber: payableNumber,
            timeStamp: timeStamp
          }
        });
        // 清除本地存储的标识
        localStorage.removeItem('isFromUploadContas');
        localStorage.removeItem('uploadContasPayableNumber');
        localStorage.removeItem('uploadContasTimeStamp');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #f7f8fa;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: rgba(29, 33, 41, 0.42);
  backdrop-filter: blur(2px);
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
  width: calc(100% - #{$sideBarWidth});
  background: #ffffff;
  border: none;
  border-bottom: 1px solid #e5e6eb;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  transition: width 0.2s cubic-bezier(0.34, 0.69, 0.1, 1);
}

.hideSidebar .fixed-header {
  width: calc(100% - #{$sideBarCollapseWidth});
}

.mobile .fixed-header {
  top: 0;
  right: 0;
  width: 100%;
  border-radius: 0;
}
</style>
